import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBitbucketIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 134,
	height: 121,
	viewBox: "0 0 134 121",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.33039 0.409059C1.96934 0.378403 0.0304812 2.26778 0.000363031 4.62883C-0.00286392 4.87677 0.0154222 5.12471 0.0552212 5.36942L18.2057 115.555C18.6726 118.338 21.0702 120.384 23.8927 120.408H110.968C113.086 120.435 114.904 118.907 115.243 116.816L133.394 5.39093C133.772 3.06 132.189 0.864059 129.858 0.485968C129.613 0.446169 129.366 0.427883 129.118 0.43111L4.33039 0.409059ZM80.7591 80.0442H52.967L45.4417 40.7292H87.4937L80.7591 80.0442Z",
			fill: "#2684FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M127.511 40.6738H87.4163L80.6871 79.9576H52.917L20.1274 118.878C21.1665 119.777 22.4917 120.277 23.8653 120.288H110.892C113.009 120.315 114.826 118.789 115.165 116.7L127.511 40.6738Z",
			fill: "url(#paint0_linear_1060_31)"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_1060_31",
			x1: 136.813,
			y1: 51.7396,
			x2: 90.4932,
			y2: 117.506,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .18,
				stopColor: "#0052CC"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#2684FF"
			})]
		}) })
	]
});
export default SvgBitbucketIcon;
